import React from 'react';
import { Container, Button, Modal, Popup, Form, Icon, Input, Dropdown } from 'semantic-ui-react'
import DataTable from 'react-data-table-component';
import { useSelector, useDispatch } from 'react-redux';
import { getDepartment } from '../Redux/Actions/DepartmentAction'
import {
   deletePost,
   getPost,
   savePost,
   updatePost,
   statusPost
} from '../Redux/Actions/PostAction'
import { Formik } from 'formik'
import * as Yup from 'yup';
import { toast } from 'react-toastify';
import DatePicker from "react-datepicker";
import moment from "moment";
import ConfirmModal from '../Components/ConfirmModal';
import TableLoader from '../Components/TableLoader';
import { getAssets } from '../Redux/Actions/AssetsAction';
import { getShift } from '../Redux/Actions/ShiftAction';
import PostExpandedComponent from "../Components/PostExpandedComponent";

const Post = () => {

   const inputRef = React.useRef();
   const dispatch = useDispatch()
   React.useEffect(() => {
      dispatch(getDepartment(toast, authToken))
      dispatch(getPost(toast, authToken))
      dispatch(getAssets(toast, authToken))
      dispatch(getShift(toast, authToken))
      inputRef.current && inputRef.current.focus();
   }, [])

   const authToken = localStorage.getItem('accessToken');
   const [openModal, setOpenModal] = React.useState(false)
   const [openConfirm, setOpenConfirm] = React.useState(false)
   const [actionMode, setActionMode] = React.useState('');
   const [rowData, setRowData] = React.useState([]);
   const [searchInput, setSearchInput] = React.useState('');
   const loadingData = useSelector(state => state.loadingReducer.loadingPayload);
   const isPageLoading = loadingData && loadingData.string === 'list' ? loadingData.status : false

   const departmentData = useSelector(state => state.departmentReducer.departmentPayload);
   const departmentList = departmentData && departmentData
      .filter(item => item.status === "A")
      .map(item => {
         return {
            key: item.id,
            value: item.id,
            text: item.name
         }
      })
   const postData = useSelector(state => state.postReducer.postPayload)
   const filteredItems = postData && postData.filter(item => (
      item.name.toLowerCase().includes(searchInput.toLowerCase())
   ));

   const assetNameData = useSelector(state => state.assetsReducer.assetsPayload)
   const assetNameList = assetNameData && assetNameData
      .filter(item => item.status === "A")
      .map(item => {
         return {
            key: item.id,
            value: item.id,
            text: item.name
         }
      })
   const shiftData = useSelector(state => state.shiftReducer.shiftPayload)
   const shiftList = shiftData && shiftData
      .filter(item => item.status === "A")
      .map((item => {
         return {
            key: item.id,
            value: item.id,
            text: item.name
         }
      }))

   // console.log(shiftList);

   const searchComponent = <Input icon='search' placeholder='Search..' value={searchInput} onChange={e => setSearchInput(e.target.value)} />

   const actions = <React.Fragment>
      <Button
         primary
         onClick={() => (setOpenModal(true), setActionMode('Add'))}>
         <Icon name='add circle' />
         Add New
      </Button>
   </React.Fragment>;

   const conditionalRowStyles = [
      {
         when: row => row.status === 'I',
         style: {
            backgroundColor: '#f3f3f3',
            color: 'rgb(132 132 132 / 87%)'
         },
      }
   ]

   const columns = [
      {
         name: 'Post Name',
         selector: 'name',
         sortable: true,
      },
      {
         name: 'Department',
         selector: 'department.name',
         sortable: true,
      },
      {
         name: 'Contact number',
         selector: 'department.contact_number',
         sortable: true,
      },
      {
         name: 'Email',
         selector: 'department.email',
         sortable: true,
      },
      {
         name: 'Action',
         sortable: false,
         allowOverflow: true,
         button: true,
         width: '56px',
         right: true,
         cell: (data) =>
            <Popup
               style={{ padding: 0 }}
               position='left center'
               trigger={<Button color='basic' icon="ellipsis vertical" />}
               on='click'>
               <Button.Group vertical labeled icon color='basic' style={{ border: 0 }}>
                  <Button
                     icon='edit'
                     content='Edit'
                     onClick={() => (
                        setRowData(data),
                        setOpenModal(true),
                        setActionMode('Edit'))} />
                  <Button
                     icon='trash alternate outline'
                     content='Delete'
                     onClick={() => (
                        setOpenConfirm(true),
                        setRowData(data),
                        setActionMode('Delete'))} />
                  {data.status === 'I' ?
                     <Button icon='lock open' content='Active'
                        onClick={() => (
                           setOpenConfirm(true),
                           setRowData(data),
                           setActionMode('Active'))} /> :
                     <Button icon='lock' content='InActive'
                        onClick={() => (
                           setOpenConfirm(true),
                           setRowData(data),
                           setActionMode('InActive'))} />}
               </Button.Group>
            </Popup>
      },
   ];

   const customStyles = {
      header: {
         style: {
            minHeight: '40px',
         },
      },
      headRow: {
         style: {
            backgroundColor: 'rgb(33 133 208)',
            height: '10px',
            minHeight: '40px'
         },
      },
      table: {
         minHeight: '400px'
      },
      headCells: {
         style: {
            backgroundColor: 'rgb(33 133 208)',
            color: '#FFF',
            fontSize: '16px',
            fontWeight: '700',
         },
      }
   }

   const validationSchema = Yup.object().shape({
      name: Yup.string()
         .min(2, 'Post name is too short!')
         .max(50, 'Post name is too Long!')
         .required('Post name is required'),
      department_id: Yup.string()
         .required('Contact person is required'),
      start_time: Yup.string()
         .required('Start time is required'),
      end_time: Yup.string()
         .required('End time is required')
   });


   return (
      <div>
         <Container fluid>
            <DataTable
               title='Post Management'
               columns={columns}
               customStyles={customStyles}
               data={filteredItems}
               actions={actions}
               pagination={true}
               paginationResetDefaultPage={true}
               conditionalRowStyles={conditionalRowStyles}
               persistTableHead
               subHeader
               expandableRows
               expandableRowsComponent={<PostExpandedComponent />}
               subHeaderComponent={searchComponent}
               progressPending={isPageLoading}
               progressComponent={<TableLoader />}
            />
            <Modal open={openModal} size='tiny'>
               <Formik
                  enableReinitialize
                  initialValues={actionMode === "Add" ? {
                     name: "",
                     department_id: "",
                     location: "",
                     start_time: new Date("start_time Wed Jun 16 2021 10:00:00 GMT+0530"),
                     end_time: new Date("start_time Wed Jun 16 2021 18:00:00 GMT+0530"),
                     total_time: '',
                     assets: [],
                     shifts: []
                  } :
                     {
                        name: rowData.name,
                        location: rowData.location,
                        department_id: rowData.department_id,
                        start_time: rowData.start_time,
                        end_time: rowData.end_time,
                        total_time: rowData.total_time,
                        assets: rowData.assets,
                        shifts: rowData.shifts
                     }
                  }
                  validationSchema={validationSchema}
                  onSubmit={(values, actions) => {
                     actionMode === "Add" ?
                        dispatch(savePost(values, actions, actionMode, toast, authToken)) :
                        dispatch(updatePost(values, rowData.id, actions, setOpenModal, actionMode, toast, authToken))
                  }
                  }>
                  {({
                     values,
                     errors,
                     touched,
                     handleChange,
                     handleBlur,
                     isSubmitting,
                     handleSubmit,
                     setFieldValue
                  }) => (
                     <React.Fragment>
                        <Modal.Header>{actionMode === "Edit" ? 'Update Post' : 'Create Post'}</Modal.Header>
                        <Modal.Content>
                           <Form id="myForm">
                              <Form.Group widths='equal'>
                                 <Form.Field>
                                    <label>Department</label>
                                    <Dropdown
                                       error={errors.department_id && touched.department_id ? true : false}
                                       options={departmentList}
                                       placeholder='Select Department'
                                       selection
                                       search
                                       name="department_id"
                                       value={values.department_id}
                                       onChange={(e, { name, value }) => {
                                          setFieldValue('department_id', value)
                                       }}
                                    />
                                 </Form.Field>
                                 <Form.Input
                                    error={errors.name && touched.name ? { content: errors.name } : false}
                                    fluid
                                    label='Post Name'
                                    placeholder='Post Name'
                                    type="text"
                                    value={values.name}
                                    onChange={handleChange('name')}
                                 />
                              </Form.Group>
                              <Form.Group widths='equal'>
                                 <Form.Field>
                                    <label>Start Time</label>
                                    <DatePicker
                                       selected={values.start_time}
                                       value={values.start_time}
                                       onChange={date => (setFieldValue("start_time", date))}
                                       showTimeSelect
                                       showTimeSelectOnly
                                       timeIntervals={15}
                                       timeCaption="Start Time"
                                       dateFormat="h:mm aa"
                                    />
                                 </Form.Field>
                                 <Form.Field>
                                    <label>Start Time</label>
                                    <DatePicker
                                       selected={values.end_time}
                                       value={values.end_time}
                                       onChange={(date) => setFieldValue("end_time", date)}
                                       showTimeSelect
                                       showTimeSelectOnly
                                       timeIntervals={15}
                                       timeCaption="End Time"
                                       dateFormat="h:mm aa"
                                    />
                                 </Form.Field>
                                 <Form.Input
                                    error={errors.total_time && touched.total_time ? { content: errors.total_time } : false}
                                    fluid
                                    label='Total Hour'
                                    readOnly
                                    placeholder='HH:MM'
                                    type="text"
                                    value={moment(values.end_time).diff(moment(values.start_time), 'hours')}
                                    onChange={handleChange('total_time')}
                                 />
                              </Form.Group>
                              <Form.Field>
                                 <label>Assets Required</label>
                                 <Dropdown
                                    error={errors.assets && touched.assets ? { content: errors.assets } : false}
                                    placeholder='Assets Required'
                                    fluid
                                    multiple
                                    search
                                    selection
                                    value={values.assets}
                                    options={assetNameList}
                                    // onSearchChange={}
                                    onChange={(e, { value }) => setFieldValue('assets', value)}
                                 />
                              </Form.Field>
                              <Form.Field>
                                 <label>Shift</label>
                                 <Dropdown
                                    error={errors.shifts && touched.shifts ? { content: errors.shifts } : false}
                                    placeholder='Shift is required'
                                    fluid
                                    multiple
                                    search
                                    selection
                                    value={values.shifts}
                                    options={shiftList}
                                    // onSearchChange={}
                                    onChange={(e, { value }) => setFieldValue('shifts', value)}
                                 />
                              </Form.Field>
                           </Form>
                        </Modal.Content>
                        <Modal.Actions>
                           <Button negative type="cancel" onClick={() => (dispatch(getPost(toast, authToken)), setOpenModal(false))}>
                              Close
                           </Button>
                           <Button
                              content={actionMode === "Edit" ? "Save" : "Create"}
                              type="submit"
                              labelPosition='right'
                              icon='checkmark'
                              loading={isSubmitting}
                              onClick={handleSubmit}
                              positive
                              form="myForm"
                              key="submit"
                              htmlType="submit"
                           />
                        </Modal.Actions>
                     </React.Fragment>
                  )}
               </Formik>
            </Modal>
            <Formik
               enableReinitialize
               initialValues={{
                  id: rowData.id,
                  status: actionMode === 'InActive' ? "I" : actionMode === 'Active' ? "A" : "D"
               }}
               onSubmit={(values, actions) => {
                  actionMode === 'Delete' ?
                     dispatch(deletePost(values, actions, setOpenConfirm, toast, authToken)) :
                     dispatch(statusPost(values, actions, setOpenConfirm, toast, authToken))
               }}>
               {({
                  isSubmitting,
                  handleSubmit
               }) => (
                  <ConfirmModal
                     icon="trash alternate outline"
                     color="red"
                     open={openConfirm}
                     cancelText="Cancel"
                     comfirmText="Delete"
                     header={
                        actionMode === 'Delete' ? 'Delete Record' :
                           actionMode === 'InActive' ? 'Inactive Record' :
                              actionMode === 'Active' ? 'Active Rocord' : null
                     }
                     content={
                        actionMode === 'Delete' ? 'Data rocord will lost' :
                           actionMode === 'InActive' ? 'Data record will inactive.' :
                              actionMode === 'Active' ? 'Data record will active?' : null
                     }
                     onCancel={() => setOpenConfirm(false)}
                     onConfirm={handleSubmit}
                     loading={isSubmitting} />
               )}
            </Formik>
         </Container>
      </div>
   )
}

export default Post